import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/login/Login";
import MiddlewareAuth from "./components/middleware/MiddlewareAuth";
import Loading from "./components/main/Loading";
import Toast from "./components/main/Toast";
import Home from "./pages/home/Home";
import Team from "./pages/users/Team";
import AddUpdTeam from "./pages/users/AddUpdTeam";
import { ToastContainer } from "react-toastify";
import ForgotPassword from "./pages/login/ForgotPassw";
import AsignPassword from "./pages/login/AsignPassword";
import Accounting from "./pages/payments/accounting/Accounting";
import Clients from "./pages/clients/Clients";
import Suscription from "./pages/suscriptions/Suscription";
import PaymentDetail from "./pages/payments/accounting/PaymentDetail";
import ProfileAccounting from "./pages/users/profile-accounting/ProfileAccounting";
import Profile from "./pages/users/Profile";
import Operators from "./pages/operators/Operators";
import AddUpdOperator from "./pages/operators/AddUpdOperator";
import TrailerTruck from "./pages/trailerTruck/TrailerTruck";
import Trucks from "./pages/trailerTruck/Trucks";
import Trailers from "./pages/trailerTruck/Trailers";
import Loads from "./pages/Loads/Loads";
import PaymentMethods from "./pages/payments/paymentMethods/PaymentMethods";
import Settlement from "./pages/settlements/Settlements";
import AddSettlements from "./pages/settlements/addUpdSettlements/AddSettlements";
import SettlementDetail from "./pages/settlements/Detail/SettlementDetail";
import AccountingSettlements from "./pages/settlements/Accounting/AccountingSettlements";
import AccountSettlement from "./pages/settlements/Accounting/AccountSettlement";
import ServiceOrders from "./pages/serviceOrders/ServiceOrders";
import OrderAndRequestService from "./pages/serviceOrders/Order&RequestService";
import ServiceRequest from "./pages/serviceOrders/serviceRequest/ServiceRequest";
import Suppliers from "./pages/suppliers/Suppliers";
import ConfigurationAlerts from "./pages/notifications/ConfigurationAlerts";
import { useEffect, useRef } from "react";
import { getAuthUser, isUserAuthenticated } from "./helpers/configRoutes/backend_helper";
import { infoToastCenter } from "./helpers/Toast";
import { getEchoInstance } from "./helpers/realtime/echo";
import IAOperations from "./pages/iaOperations/IAOperations";
import LoadsPre from "./pages/iaOperations/loads/LoadsPre";
import ServiceOrdersPre from "./pages/iaOperations/serviceOrders/ServiceOrdersPre";
import Rols from "./pages/rols/Rols";
import AddUpdLoad from "./pages/Loads/createEditLoad/AddUpdLoad";
import Support from "./pages/support/Support";

const App = () => {

  const isAuth = isUserAuthenticated();
    const userAuth = getAuthUser();
  
    const echoRef = useRef(null);
  
    useEffect(() => {
      if (isAuth && userAuth?.id && !echoRef.current) {
        echoRef.current = getEchoInstance();
    
        echoRef.current
          .private(`notificaciones.${userAuth.id}`)
          .listen('.NotificacionSent', (data) => {
            console.log(data.notificacion, '🔔 Notificación recibida');
            const accion = data.notificacion.history.action;
            infoToastCenter(`${accion.description}; ${accion.description}`, 'bottom-right');
          });
      }
    
      return () => {
        if (echoRef.current) {
          echoRef.current.leave(`notificaciones.${userAuth.id}`);
        }
      };
    }, [isAuth, userAuth]);

  return (
    <>
      <Toast />
      <ToastContainer />
      <Loading />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<AsignPassword />} />
          <Route path="/confirm-account/:token" element={<AsignPassword />} />

          <Route
            path="/"
            element={
              <MiddlewareAuth>
                <Home />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/team"
            element={
              <MiddlewareAuth>
                <Team />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/team-upadd/:id?"
            element={
              <MiddlewareAuth>
                <AddUpdTeam />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/acount-profile"
            element={
              <MiddlewareAuth>
                <ProfileAccounting />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/profile"
            element={
              <MiddlewareAuth>
                <Profile />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/subscriptions"
            element={
              <MiddlewareAuth>
                <Suscription />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/accounting"
            element={
              <MiddlewareAuth>
                <Accounting />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/payment-details/:id"
            element={
              <MiddlewareAuth>
                <PaymentDetail />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/payment-methods"
            element={
              <MiddlewareAuth>
                <PaymentMethods />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/operators"
            element={
              <MiddlewareAuth>
                <Operators />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/operator-upadd/:id?"
            element={
              <MiddlewareAuth>
                <AddUpdOperator />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/ia-trk/:id?"
            element={
              <MiddlewareAuth>
                <ServiceOrdersPre />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/ia-loads/:id?"
            element={
              <MiddlewareAuth>
                <LoadsPre />
              </MiddlewareAuth>
            }
          />

          

          
          <Route
            path="/trucks-trailers"
            element={
              <MiddlewareAuth>
                <TrailerTruck />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/trucks"
            element={
              <MiddlewareAuth>
                <Trucks />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/trailers"
            element={
              <MiddlewareAuth>
                <Trailers />
              </MiddlewareAuth>
            }
          />
          {/*Loads*/}
          <Route
            path="/loads"
            element={
              <MiddlewareAuth>
                <Loads />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/load/:id"
            element={
              <MiddlewareAuth>
                <AddUpdLoad />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/loads-new"
            element={
              <MiddlewareAuth>
                <AddUpdLoad />
              </MiddlewareAuth>
            }
          />



          <Route
            path="/settlements"
            element={
              <MiddlewareAuth>
                <Settlement />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/settlement/detail/:id"
            element={
              <MiddlewareAuth>
                <SettlementDetail />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/addSettlements/:id?"
            element={
              <MiddlewareAuth>
                <AddSettlements />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/accounting-settlements"
            element={
              <MiddlewareAuth>
                <AccountingSettlements />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/account-settlement/:id"
            element={
              <MiddlewareAuth>
                <AccountSettlement />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/clients"
            element={
              <MiddlewareAuth>
                <Clients />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/service-orders"
            element={
              <MiddlewareAuth>
                <ServiceOrders />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/services"
            element={
              <MiddlewareAuth>
                <OrderAndRequestService />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/services-request"
            element={
              <MiddlewareAuth>
                <ServiceRequest />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/suppliers"
            element={
              <MiddlewareAuth>
                <Suppliers />
              </MiddlewareAuth>
            }
          />
          <Route
            path="/configuration-alerts"
            element={
              <MiddlewareAuth>
                <ConfigurationAlerts />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/ai-operations"
            element={
              <MiddlewareAuth>
                <IAOperations />
              </MiddlewareAuth>
            }
          />

          <Route
            path="/rols"
            element={
              <MiddlewareAuth>
                <Rols />
              </MiddlewareAuth>
            }
          />


          
          

          <Route
            path="/support"
            element={
              <MiddlewareAuth>
                <Support />
              </MiddlewareAuth>
            }
          />
        </Routes>
      </Router>
    </>
  );
};

export default App;
